import React from "react";
import { Box } from "@mui/material";
import AuctionCard from "./auctionCard";
import useMediaQuery from "@mui/material/useMediaQuery";

const list = [1, 2, 3, 4, 5, 6];

function AuctionListingContainer({
  handleSnackbarOpen,
  setShowSimilar,
  setShowShareModal,
  handleContactSellerModal,
  setContactSellerLoggedIn,
  showCompare,
  comparing,
  setShowCompare,
  loggedIn,
  count,
  handleLogInModal,
}) {
  const tabMatch = useMediaQuery("(max-width:900px)");
  const mobMatch = useMediaQuery("(max-width:600px)");

  return (
    <Box
      sx={{
        display: { xs: "flex", md: "block" },
        justifyContent: { xs: "center" },
        flexWrap: "wrap",
        width: { xs: "100vw", md: "auto" },
        marginX: { xs: "auto", md: "auto" },
        columnGap: { xs: "32px", md: "0px" },
      }}
    >
      {list.map((li, i) => (
        <>
          <AuctionCard
            key={li}
            handleSnackbarOpen={handleSnackbarOpen}
            setShowSimilar={setShowSimilar}
            setShowShareModal={setShowShareModal}
            handleContactSellerModal={handleContactSellerModal}
            setContactSellerLoggedIn={setContactSellerLoggedIn}
            showCompare={showCompare}
            comparing={comparing}
            setShowCompare={setShowCompare}
            loggedIn={loggedIn}
            count={count}
            handleLogInModal={handleLogInModal}
            sx={{
              marginBottom: "24px",
              flex: { xs: "100%", sm: "50%", md: "0 1 auto" },
            }}
            isPro={i >= 3}
          />
          {!mobMatch && i !== list.length - 1 && (
            <Box
              sx={{
                height: "1px",
                width: tabMatch ? "93.8%" : "100%",
                backgroundColor: "#D6D6D6",
                marginBottom: "24px",
              }}
            ></Box>
          )}
        </>
      ))}
    </Box>
  );
}

export default AuctionListingContainer;
